import React from "react";
import Tags from "../Tags";
import TagSkeleton from "../TagSkeleton";

interface TagFieldProps {
  label: string;
  value: string | null;
  loading?: boolean;
  hideEmptyState?: boolean;
  children?: React.ReactNode;
}

const TagField: React.FC<TagFieldProps> = ({
  label,
  value,
  loading,
  hideEmptyState,
  children,
}) => {
  const tags = value
    ? value
        .split(",")
        .map((t) => t.trim())
        .filter(Boolean)
    : [];

  const content = loading ? (
    <TagSkeleton />
  ) : tags.length > 0 ? (
    <Tags tags={tags} />
  ) : children ? (
    children
  ) : hideEmptyState ? null : (
    <span className="text-cream-950 dark:text-cream-100 font-medium">—</span>
  );

  return (
    <div className="flex w-full flex-col gap-2">
      <span className="text-cream-800 dark:text-cream-400 text-sm font-medium">
        {label}
      </span>
      {children ? (
        <div className="flex min-h-10 items-center">{content}</div>
      ) : (
        content
      )}
    </div>
  );
};

export default TagField;
